// extracted by mini-css-extract-plugin
export default {"sidebarItem":"SidebarItem_sidebarItem__Ae3ks","active":"SidebarItem_active__lHcwI","sidebarItemIcon":"SidebarItem_sidebarItemIcon__znryi"};